import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { gql, useQuery } from '@apollo/client'

import Button from 'js/components/Button/Button'
import Flexer from 'js/components/Flexer/Flexer'
import { useSubtype } from 'js/lib/hooks/useSubtypes'

import AddIcon from 'icons/add.svg'

import SettingsType from '../../types/SettingsType'

interface Props {
    settings: SettingsType
}

const CreateContentView = ({ settings }: Props) => {
    const location = useLocation()
    const { t } = useTranslation()

    const { subtype, groupGuid, buttonSize, buttonAlignment } = settings

    /* @ts-ignore TODO: Fix ts error */
    const { name, slug } = useSubtype(subtype)

    const { data, loading } = useQuery(GET_DATA, {
        variables: {
            getGroup: !!groupGuid,
            groupGuid,
            subtype,
        },
    })
    if (loading || !data) return null

    const { viewer, group } = data

    const canCreate = group
        ? group.membership === 'joined'
        : viewer?.canWriteToContainer

    if (!canCreate) return null

    const buttonAlignments = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end',
    }

    const buttonSizes = {
        sm: 'small',
        md: 'normal',
        lg: 'large',
    }

    const createUrl = group ? `${group?.url}/${slug}/add` : `/${slug}/add`

    return (
        <Flexer justifyContent={buttonAlignments[buttonAlignment]}>
            <Button
                as={Link}
                to={createUrl}
                state={{ prevPathname: location.pathname }}
                size={buttonSizes[buttonSize]}
                variant="primary"
            >
                <AddIcon style={{ marginRight: '6px' }} />
                {t('action.create')} {name?.toLowerCase()}
            </Button>
        </Flexer>
    )
}

const GET_DATA = gql`
    query CreateContentSite(
        $subtype: String
        $getGroup: Boolean!
        $groupGuid: String
    ) {
        viewer {
            guid
            canWriteToContainer(subtype: $subtype)
        }
        group: entity(guid: $groupGuid) @include(if: $getGroup) {
            guid
            ... on Group {
                url
                membership
            }
        }
    }
`

export default CreateContentView
